<template>
  <div>
    <div class="coverShow" v-show="viseable">
      <div class="container-gj" @click="handleCloseClick">
        <div class="container-gd" @click.stop>
          <div style="position: relative; background: #fff">
            <div class="top-nav">
              <p></p>
              <p>
                {{ surveyType === 1 ? "模板预览" : "预览" }}
              </p>
              <p></p>
            </div>
            <div
              style="
                height: calc(100% - 115px);
                overflow: hidden;
                overflow-y: auto;
                display: flex;
                background: #f8f8f8;
              "
              ref="scrollContainer"
            >
              <div class="survey-container">
                <div class="survey-info">
                  <h1>
                    {{
                      surveyType === 1
                        ? dataObj.templateQuestionnaireName
                        : dataObj.questionnaireName
                    }}
                  </h1>
                  <h4>
                    {{
                      surveyType === 1
                        ? dataObj.templateQuestionnaireDescribe
                        : dataObj.questionnaireDescribe
                    }}
                  </h4>
                  <!-- <div>使用人数：{{ dataObj.useNum }}</div>
                  <div>题目数量：{{ dataObj.questionNum }}</div> -->
                </div>
                <!-- 问题列表 -->
                <div v-if="questionnaireType === '1'" class="questions-list">
                  <div
                    v-for="(item, index) in dataList"
                    :key="index"
                    @click.stop=""
                  >
                    <div class="item" v-if="item.type == QuestionType.SCQ">
                      <div style="position: relative">
                        <QuestionPreviewSCQ
                          :params="{ data: item, index: index }"
                        ></QuestionPreviewSCQ>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div class="item" v-if="item.type == QuestionType.MCQ">
                      <div style="position: relative">
                        <QuestionPreviewMCQ
                          :params="{ data: item, index: index }"
                        ></QuestionPreviewMCQ>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div class="item" v-if="item.type == QuestionType.SBQ">
                      <div style="position: relative">
                        <QuestionPreviewSBQ
                          :params="{ data: item, index: index }"
                        ></QuestionPreviewSBQ>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div class="item" v-if="item.type == QuestionType.MBQ">
                      <div style="position: relative">
                        <QuestionPreviewMBQ
                          :params="{ data: item, index: index }"
                        ></QuestionPreviewMBQ>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div class="item" v-if="item.type == QuestionType.DLQ">
                      <div style="position: relative">
                        <QuestionPreviewDLQ
                          :params="{ data: item, index: index }"
                        ></QuestionPreviewDLQ>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div class="item" v-if="item.type == QuestionType.NPS">
                      <div style="position: relative">
                        <QuestionPreviewNPS
                          :params="{ data: item, index: index }"
                        ></QuestionPreviewNPS>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div class="item" v-if="item.type == QuestionType.QA">
                      <div style="position: relative">
                        <QuestionPreviewQA
                          :params="{ data: item, index: index }"
                        ></QuestionPreviewQA>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div class="item" v-if="item.type == QuestionType.SRQ">
                      <div style="position: relative">
                        <QuestionPreviewSRQ
                          :params="{ data: item, index: index }"
                        ></QuestionPreviewSRQ>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div class="item" v-if="item.type == QuestionType.VOTE">
                      <div style="position: relative">
                        <QuestionPreviewVote
                          :params="{ data: item, index: index }"
                        ></QuestionPreviewVote>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div class="item" v-if="item.type == QuestionType.SORT">
                      <div style="position: relative">
                        <QuestionPreviewSort
                          :params="{ data: item, index: index }"
                        ></QuestionPreviewSort>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div class="item" v-if="item.type == QuestionType.SCORE">
                      <div style="position: relative">
                        <QuestionPreviewScore
                          :params="{ data: item, index: index }"
                        ></QuestionPreviewScore>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div class="item" v-if="item.type == QuestionType.WRQ">
                      <div style="position: relative">
                        <QuestionPreviewWRQ
                          :params="{ data: item, index: index }"
                        ></QuestionPreviewWRQ>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div class="item" v-if="item.type == QuestionType.REMARK">
                      <div style="position: relative">
                        <QuestionPreviewRemark
                          :params="{ data: item, index: index }"
                        ></QuestionPreviewRemark>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div class="item" v-if="item.type == QuestionType.NAME">
                      <div style="position: relative">
                        <QuestionPreviewName
                          :params="{ data: item, index: index }"
                        ></QuestionPreviewName>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div class="item" v-if="item.type == QuestionType.GENDER">
                      <div style="position: relative">
                        <QuestionPreviewGender
                          :params="{ data: item, index: index }"
                        ></QuestionPreviewGender>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div class="item" v-if="item.type == QuestionType.AGE">
                      <div style="position: relative">
                        <QuestionPreviewAge
                          :params="{ data: item, index: index }"
                        ></QuestionPreviewAge>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div class="item" v-if="item.type == QuestionType.TEL">
                      <div style="position: relative">
                        <QuestionPreviewTel
                          :params="{ data: item, index: index }"
                        ></QuestionPreviewTel>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div class="item" v-if="item.type == QuestionType.EMAIL">
                      <div style="position: relative">
                        <QuestionPreviewEmail
                          :params="{ data: item, index: index }"
                        ></QuestionPreviewEmail>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div class="item" v-if="item.type == QuestionType.DATE">
                      <div style="position: relative">
                        <QuestionPreviewDate
                          :params="{ data: item, index: index }"
                        ></QuestionPreviewDate>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div class="item" v-if="item.type == QuestionType.TIME">
                      <div style="position: relative">
                        <QuestionPreviewTime
                          :params="{ data: item, index: index }"
                        ></QuestionPreviewTime>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div class="item" v-if="item.type == QuestionType.ADDR">
                      <div style="position: relative">
                        <QuestionPreviewAddress
                          :params="{ data: item, index: index }"
                        ></QuestionPreviewAddress>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div class="item" v-if="item.type == QuestionType.IMAGE">
                      <div style="position: relative">
                        <QuestionPreviewImage
                          :params="{ data: item, index: index }"
                        ></QuestionPreviewImage>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div class="item" v-if="item.type == QuestionType.MaxDiff">
                      <div style="position: relative">
                        <QuestionPreviewMaxDiff
                          :params="{ data: item, index: index }"
                        ></QuestionPreviewMaxDiff>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div
                      class="item"
                      v-if="item.type == QuestionType.UploadFile"
                    >
                      <div style="position: relative">
                        <QuestionPreviewUploadFile
                          :params="{ data: item, index: index }"
                        ></QuestionPreviewUploadFile>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div
                      class="item"
                      v-if="item.type == QuestionType.DownloadFile"
                    >
                      <div style="position: relative">
                        <QuestionPreviewDownloadFile
                          :params="{ data: item, index: index }"
                        ></QuestionPreviewDownloadFile>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div class="item" v-if="item.type == QuestionType.CASCADER">
                      <div style="position: relative">
                        <QuestionPreviewCASCADER
                          :params="{ data: item, index: index }"
                        ></QuestionPreviewCASCADER>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div class="item" v-if="item.type == QuestionType.BDQ">
                      <div style="position: relative">
                        <QuestionPreviewBDQ
                          :params="{ data: item, index: index }"
                        ></QuestionPreviewBDQ>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div class="item" v-if="item.type == QuestionType.IDQ">
                      <div style="position: relative">
                        <QuestionPreviewIDQ
                          :params="{ data: item, index: index }"
                        ></QuestionPreviewIDQ>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div class="item" v-if="item.type == QuestionType.ELQ">
                      <div style="position: relative">
                        <QuestionPreviewELQ
                          :params="{ data: item, index: index }"
                        ></QuestionPreviewELQ>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div class="item" v-if="item.type == QuestionType.WX">
                      <div style="position: relative">
                        <QuestionPreviewWX
                          :params="{ data: item, index: index }"
                        ></QuestionPreviewWX>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div class="item" v-if="item.type == QuestionType.TITLE">
                      <div style="position: relative">
                        <QuestionPreviewTitle
                          :params="{ data: item, index: index }"
                        ></QuestionPreviewTitle>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div class="item" v-if="item.type == QuestionType.ImageSCQ">
                      <div style="position: relative">
                        <QuestionPreviewImageScq
                          :params="{ data: item, index: index }"
                          :repeat="2"
                        ></QuestionPreviewImageScq>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div class="item" v-if="item.type == QuestionType.ImageMCQ">
                      <div style="position: relative">
                        <QuestionPreviewImageMcq
                          :params="{ data: item, index: index }"
                          :repeat="2"
                        ></QuestionPreviewImageMcq>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div
                      class="item"
                      v-if="item.type == QuestionType.MatrixSCQ"
                    >
                      <div style="position: relative">
                        <QuestionPreviewMatrixScq
                          :params="{ data: item, index: index }"
                        ></QuestionPreviewMatrixScq>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div
                      class="item"
                      v-if="item.type == QuestionType.MatrixMCQ"
                    >
                      <div style="position: relative">
                        <QuestionPreviewMatrixMcq
                          :params="{ data: item, index: index }"
                        ></QuestionPreviewMatrixMcq>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div
                      class="item"
                      v-if="item.type == QuestionType.ImageOrVideo"
                    >
                      <div style="position: relative">
                        <QuestionPreviewImageOrVideo
                          :params="{ data: item, index: index }"
                        ></QuestionPreviewImageOrVideo>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div
                      class="item"
                      v-if="item.type == QuestionType.Signature"
                    >
                      <div style="position: relative">
                        <QuestionPreviewSignature
                          :params="{ data: item, index: index }"
                        ></QuestionPreviewSignature>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div
                      class="item"
                      v-if="item.type == QuestionType.PageBreak"
                    >
                      <div style="position: relative">
                        <QuestionPreviewPageBreak
                          :params="{ data: item, index: index }"
                        ></QuestionPreviewPageBreak>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div
                      class="item"
                      v-if="item.type == QuestionType.Customize"
                    >
                      <div style="position: relative">
                        <QuestionPreviewCustomize
                          :params="{ data: item, index: index }"
                        ></QuestionPreviewCustomize>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="questionnaireType === '2'" class="questions-list">
                  <div
                    v-for="(item, index) in dataList"
                    :key="index"
                    @click.stop=""
                  >
                    <div class="item" v-if="item.type == QuestionType.SCQ">
                      <div style="position: relative">
                        <ExamPreviewSCQ
                          :params="{ data: item, index: index }"
                        ></ExamPreviewSCQ>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div class="item" v-if="item.type == QuestionType.MCQ">
                      <div style="position: relative">
                        <ExamPreviewMCQ
                          :params="{ data: item, index: index }"
                        ></ExamPreviewMCQ>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div class="item" v-if="item.type == QuestionType.SBQ">
                      <div style="position: relative">
                        <ExamPreviewSBQ
                          :params="{ data: item, index: index }"
                        ></ExamPreviewSBQ>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div class="item" v-if="item.type == QuestionType.MBQ">
                      <div style="position: relative">
                        <ExamPreviewMBQ
                          :params="{ data: item, index: index }"
                        ></ExamPreviewMBQ>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div class="item" v-if="item.type == QuestionType.TFQ">
                      <div style="position: relative">
                        <ExamPreviewTFQ
                          :params="{ data: item, index: index }"
                        ></ExamPreviewTFQ>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div class="item" v-if="item.type == QuestionType.QA">
                      <div style="position: relative">
                        <ExamPreviewQA
                          :params="{ data: item, index: index }"
                        ></ExamPreviewQA>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div class="item" v-if="item.type == QuestionType.IMAGE">
                      <div style="position: relative">
                        <ExamPreviewIMAGE
                          :params="{ data: item, index: index }"
                        ></ExamPreviewIMAGE>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div
                      class="item"
                      v-if="item.type == QuestionType.ClozeTest"
                    >
                      <div style="position: relative">
                        <ExamPreviewClozeTest
                          :params="{ data: item, index: index }"
                        ></ExamPreviewClozeTest>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div class="item" v-if="item.type == QuestionType.NAME">
                      <div style="position: relative">
                        <QuestionPreviewName
                          :params="{ data: item, index: index }"
                        ></QuestionPreviewName>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div class="item" v-if="item.type == QuestionType.GENDER">
                      <div style="position: relative">
                        <QuestionPreviewGender
                          :params="{ data: item, index: index }"
                        ></QuestionPreviewGender>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div class="item" v-if="item.type == QuestionType.AGE">
                      <div style="position: relative">
                        <QuestionPreviewAge
                          :params="{ data: item, index: index }"
                        ></QuestionPreviewAge>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div class="item" v-if="item.type == QuestionType.TEL">
                      <div style="position: relative">
                        <QuestionPreviewTel
                          :params="{ data: item, index: index }"
                        ></QuestionPreviewTel>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div class="item" v-if="item.type == QuestionType.EMAIL">
                      <div style="position: relative">
                        <QuestionPreviewEmail
                          :params="{ data: item, index: index }"
                        ></QuestionPreviewEmail>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div class="item" v-if="item.type == QuestionType.DATE">
                      <div style="position: relative">
                        <QuestionPreviewDate
                          :params="{ data: item, index: index }"
                        ></QuestionPreviewDate>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div class="item" v-if="item.type == QuestionType.TIME">
                      <div style="position: relative">
                        <QuestionPreviewTime
                          :params="{ data: item, index: index }"
                        ></QuestionPreviewTime>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div class="item" v-if="item.type == QuestionType.ADDR">
                      <div style="position: relative">
                        <QuestionPreviewAddress
                          :params="{ data: item, index: index }"
                        ></QuestionPreviewAddress>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div class="item" v-if="item.type == QuestionType.BDQ">
                      <div style="position: relative">
                        <QuestionPreviewBDQ
                          :params="{ data: item, index: index }"
                        ></QuestionPreviewBDQ>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div class="item" v-if="item.type == QuestionType.IDQ">
                      <div style="position: relative">
                        <QuestionPreviewIDQ
                          :params="{ data: item, index: index }"
                        ></QuestionPreviewIDQ>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div class="item" v-if="item.type == QuestionType.ELQ">
                      <div style="position: relative">
                        <QuestionPreviewELQ
                          :params="{ data: item, index: index }"
                        ></QuestionPreviewELQ>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div class="item" v-if="item.type == QuestionType.WX">
                      <div style="position: relative">
                        <QuestionPreviewWX
                          :params="{ data: item, index: index }"
                        ></QuestionPreviewWX>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div
                      class="item"
                      v-if="item.type == QuestionType.Customize"
                    >
                      <div style="position: relative">
                        <QuestionPreviewCustomize
                          :params="{ data: item, index: index }"
                        ></QuestionPreviewCustomize>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="questionnaireType === '3'" class="questions-list">
                  <div
                    v-for="(item, index) in dataList"
                    :key="index"
                    @click.stop=""
                  >
                    <div
                      class="item"
                      v-if="item.type == QuestionType.EvaluationSCQ"
                    >
                      <div style="position: relative">
                        <EvaluationPreviewSCQ
                          :params="{ data: item, index: index }"
                        ></EvaluationPreviewSCQ>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div
                      class="item"
                      v-if="item.type == QuestionType.EvaluationMCQ"
                    >
                      <div style="position: relative">
                        <EvaluationPreviewMCQ
                          :params="{ data: item, index: index }"
                        ></EvaluationPreviewMCQ>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div
                      class="item"
                      v-if="item.type == QuestionType.EvaluationWRQ"
                    >
                      <div style="position: relative">
                        <EvaluationPreviewWRQ
                          :params="{ data: item, index: index }"
                        ></EvaluationPreviewWRQ>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div
                      class="item"
                      v-if="item.type == QuestionType.EvaluationNPS"
                    >
                      <div style="position: relative">
                        <EvaluationPreviewNPS
                          :params="{ data: item, index: index }"
                        ></EvaluationPreviewNPS>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div
                      class="item"
                      v-if="item.type == QuestionType.EvaluationScore"
                    >
                      <div style="position: relative">
                        <EvaluationPreviewScore
                          :params="{ data: item, index: index }"
                        ></EvaluationPreviewScore>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div
                      class="item"
                      v-if="item.type == QuestionType.TextDescription"
                    >
                      <div style="position: relative">
                        <EvaluationPreviewDesc
                          :params="{ data: item, index: index }"
                        ></EvaluationPreviewDesc>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div class="item" v-if="item.type == QuestionType.NAME">
                      <div style="position: relative">
                        <EvaluationPreviewName
                          :params="{ data: item, index: index }"
                        ></EvaluationPreviewName>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div class="item" v-if="item.type == QuestionType.GENDER">
                      <div style="position: relative">
                        <EvaluationPreviewGender
                          :params="{ data: item, index: index }"
                        ></EvaluationPreviewGender>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div class="item" v-if="item.type == QuestionType.AGE">
                      <div style="position: relative">
                        <EvaluationPreviewAge
                          :params="{ data: item, index: index }"
                        ></EvaluationPreviewAge>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div class="item" v-if="item.type == QuestionType.ELQ">
                      <div style="position: relative">
                        <EvaluationPreviewELQ
                          :params="{ data: item, index: index }"
                        ></EvaluationPreviewELQ>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div class="item" v-if="item.type == QuestionType.DATE">
                      <div style="position: relative">
                        <EvaluationPreviewDate
                          :params="{ data: item, index: index }"
                        ></EvaluationPreviewDate>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div class="item" v-if="item.type == QuestionType.ADDR">
                      <div style="position: relative">
                        <EvaluationPreviewAddress
                          :params="{ data: item, index: index }"
                        ></EvaluationPreviewAddress>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div class="item" v-if="item.type == QuestionType.Industry">
                      <div style="position: relative">
                        <EvaluationPreviewIndustry
                          :params="{ data: item, index: index }"
                        ></EvaluationPreviewIndustry>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div
                      class="item"
                      v-if="item.type == QuestionType.Occupation"
                    >
                      <div style="position: relative">
                        <EvaluationPreviewOccupation
                          :params="{ data: item, index: index }"
                        ></EvaluationPreviewOccupation>
                        <div class="mask-div"></div>
                      </div>
                    </div>

                    <div
                      class="item"
                      v-if="item.type == QuestionType.EvaluationMatrixSCQ"
                    >
                      <div style="position: relative">
                        <EvaluationPreviewMatrixScq
                          :params="{ data: item, index: index }"
                        ></EvaluationPreviewMatrixScq>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div
                      class="item"
                      v-if="item.type == QuestionType.ImageOrVideo"
                    >
                      <div style="position: relative">
                        <EvaluationPreviewImageOrVideo
                          :params="{ data: item, index: index }"
                        ></EvaluationPreviewImageOrVideo>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div class="item" v-if="item.type == QuestionType.Audio">
                      <div style="position: relative">
                        <EvaluationPreviewAudio
                          :params="{
                            data: item,
                            index: index,
                            progressWidth: 230,
                          }"
                        ></EvaluationPreviewAudio>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                    <div
                      class="item"
                      v-if="item.type == QuestionType.Customize"
                    >
                      <div style="position: relative">
                        <QuestionPreviewCustomize
                          :params="{ data: item, index: index }"
                        ></QuestionPreviewCustomize>
                        <div class="mask-div"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <button
              v-if="surveyType === 1"
              class="free-use-btn"
              @click="freeUseBtn"
            >
              免费使用
            </button>
            <div v-else class="bottom-btn">
              <div class="bottom-btn-item" @click="editClick">
                <img
                  src="https://ossfastmake.mustke.com/qrCode/tupian/1743576458244.png"
                  alt=""
                />
                <p>重新编辑</p>
              </div>
              <div class="bottom-btn-line"></div>
              <div class="bottom-btn-item" @click="endMethod">
                <img
                  src="https://ossfastmake.mustke.com/qrCode/tupian/1743576482702.png"
                  alt=""
                />
                <p>结束问卷</p>
              </div>
              <!-- <div v-if="dataObj.releaseStatus === 2">
                <img
                  src="https://ossfastmake.mustke.com/qrCode/tupian/1743576498738.png"
                  alt=""
                />
                <p>发布问卷</p>
              </div> -->
            </div>
          </div>
          <div class="center-line"></div>
          <div class="right-container">
            <div class="top-nav">
              <p></p>
              <p>分享</p>
              <i
                class="fa-solid fa-circle-xmark"
                style="color: #8290a3; cursor: pointer"
                @click="handleCloseClick"
              ></i>
            </div>
            <div v-if="surveyType === 2" class="tab-container">
              <div
                class="tab-left"
                :class="tabIndex === 0 ? 'tab-active' : 'tab-inactive'"
                @click="tabIndex = 0"
              >
                下载活动二维码
              </div>
              <div
                class="tab-right"
                :class="tabIndex === 1 ? 'tab-active' : 'tab-inactive'"
                @click="tabIndex = 1"
              >
                嵌入公众号/文章
              </div>
            </div>
            <div v-if="tabIndex === 0" class="download-container">
              <img
                :src="qrcodeUrl"
                alt=""
                style="width: 80%; margin-top: 15px"
              />
              <div
                style="
                  display: flex;
                  margin-top: 10px;
                  width: 100%;
                  justify-content: flex-start;
                  padding: 0 10px;
                  box-sizing: border-box;
                "
              >
                <img
                  :src="icon"
                  alt=""
                  style="width: 30px; height: 30px; cursor: pointer"
                  @click="handleIconClick('')"
                />
                <span class="text-icon" @click="handleIconClick('问卷')"
                  >问卷</span
                >
                <span class="text-icon" @click="handleIconClick('测评')"
                  >测评</span
                >
                <span class="text-icon" @click="handleIconClick('考试')"
                  >考试</span
                >
                <span class="text-icon" @click="handleIconClick('调研')"
                  >调研</span
                >
                <span class="text-icon" @click="handleIconClick('调查')"
                  >调查</span
                >
                <div
                  style="
                    flex: 1;
                    background-color: #2577e4;
                    height: 30px;
                    border-radius: 8px;
                    margin-left: 5px;
                    padding: 0 5px;
                    display: flex;
                    align-items: center;
                  "
                >
                  <input
                    type="text"
                    placeholder="可输入2-4字"
                    style="width: 100%; color: #fff; font-size: 12px"
                    @blur="handleBlur"
                  />
                </div>
              </div>
              <div style="margin-top: 10px; display: flex">
                <div
                  v-for="(item, index) in colors"
                  :key="index"
                  style="
                    width: 24px;
                    height: 24px;
                    border-radius: 50%;
                    margin-right: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                  "
                  :style="{ backgroundColor: item.color }"
                  @click="handleSelectColor(index)"
                >
                  <img
                    v-if="selectColorIndex == index"
                    src="@/assets/images/duihao.svg"
                    alt=""
                    class="select-image"
                  />
                </div>
              </div>
              <div style="margin-top: 10px">
                <el-checkbox v-model="checked"
                  >我已确认中心logo为我自行修改</el-checkbox
                >
              </div>
              <button class="download-btn" @click="downloadClick">
                下载二维码
              </button>
              <div class="wj-text">问卷链接</div>
              <div class="link-bg">
                <div class="link-div">
                  <p>{{ questionLink }}</p>
                  <div style="display: flex; justify-content: space-between">
                    <div></div>
                    <button
                      class="copy-btn"
                      @click="handleCopyClick(questionLink)"
                    >
                      复制
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="embed-container">
              <div class="id-container">
                <p><span>小程序ID：</span>{{ appId }}</p>
                <div class="fuzhi-div">
                  <p><span>*</span>关联小程序时使用</p>
                  <button class="fuzhi" @click="handleCopyClick(appId)">
                    复制
                  </button>
                </div>
              </div>
              <div class="id-container">
                <p><span>页面路径：</span>{{ pagePath }}</p>
                <div class="fuzhi-div">
                  <p>嵌入菜单、文章、回复时使用</p>
                  <button class="fuzhi" @click="handleCopyClick(pagePath)">
                    复制
                  </button>
                </div>
              </div>
              <img
                :src="subscriptions"
                alt=""
                style="width: 316px; height: 485px; margin: 15px auto"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  questionnaireTemplate,
  useQuestionnaireTemplate,
  questionnaireUpdateDetail,
  questionTempList,
  closeQuestionnaire,
  getUrlLink,
  generateQRCode,
  generateQRCodeWithLogo,
} from "@/api/index.js";
import config from "@/utils/config.js";
import { PreviewComponents } from "@/utils/componentImports.js";

export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    params: {
      type: Object,
      default: () => {},
    },
    questionnaireType: {
      type: String,
      default: "1",
    },
  },
  emits: ["close-dialog"],
  components: {
    ...PreviewComponents,
  },
  data() {
    return {
      viseable: false,
      bannerImage:
        "https://ossfastmake.mustke.com/qrCode/tupian/1749715503954.png",
      answers: {
        question1: 1, // 单选题答案
        question2: [0, 1], // 多选题答案
        question3: "", // 填空题答案
        question4: 1, // 评分题答案
        question5: "鲁菜", // 下拉选择题答案
        question7: 1, // 数字选择题答案
        question8: 1, // 分数判定答案
        question9: 5, // 滑块评分答案
        question10: 1, // 滑块评分答案
      },
      dataList: [],
      surveyid: null,
      surveyType: null,
      dataObj: {},
      tabIndex: 0,
      qrcodeUrl: "",
      appId: "wx771820531f2d9634",
      questionLink: "",
      pagePath: "",
      value: "",
      QuestionType: this.$store.getters["questionType/getQuestionType"],
      subscriptions: config.subscriptions,
      scrollPosition: 0,
      icon: config.favicon.default,
      colors: [
        {
          color: "#C72827",
        },
        {
          color: "#EF6C00",
        },
        {
          color: "#F9A824",
        },
        {
          color: "#00695C",
        },
        {
          color: "#568C2E",
        },
        {
          color: "#1465C0",
        },
        {
          color: "#4626A1",
        },
        {
          color: "#4C4C4C",
        },
      ],
      selectColorIndex: null,
      logoType: 1,
      logoText: "", //字
      logoColor: "#2578E3",
      checked: true,
    };
  },
  computed: {
    sliderStyle() {
      const value = this.answers.question9;
      const min = 1;
      const max = 10;
      const percentage = ((value - min) / (max - min)) * 100;
      return {
        background: `linear-gradient(to right, #3a60ff 0%, #3a60ff ${percentage}%, #ccc ${percentage}%, #ccc 100%)`,
      };
    },
  },
  methods: {
    handleCloseClick() {
      this.$emit("close-dialog");
    },
    async fetchSurveyData(id) {
      try {
        const res = await questionnaireTemplate({
          uuid: id,
        });
        this.dataObj = res.data;
        this.bannerImage = res.data.templateThumbnailUrl;
        this.dataList = res.data.questionTemplateList;
      } catch (err) {
        console.error("获取问卷数据失败:", err);
      }
    },
    async freeUseBtn() {
      try {
        const res = await useQuestionnaireTemplate({
          uuid: this.surveyid,
        });

        if (res.code === 200) {
          this.$router.push({
            path: "/create",
            query: {
              id: res.data.uuid,
              title: res.data.questionnaireName,
              content: res.data.questionnaireDescribe,
              type: "template",
            },
          });
        }
      } catch (err) {
        console.error("获取问卷数据失败:", err);
      }
    },
    async queryDetail() {
      await questionnaireUpdateDetail({
        uuid: this.surveyid,
      })
        .then((res) => {
          if (res.code === 200) {
            console.log("res9888888888888", res, this.$store.getters.getAppId);
            this.dataObj = res.data;
            this.queryQuestionTempList();
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
    async queryQuestionTempList() {
      await questionTempList({
        uuid: this.surveyid, // 活动唯一标识
        predivStatus: 0,
      })
        .then((res) => {
          if (res.code === 200) {
            this.dataList = res.data;

            let pageLineIndex = 0;
            let questionIndex = 0;
            for (let i = 0; i < this.dataList.length; i++) {
              if (this.dataList[i].type === this.QuestionType.PageBreak) {
                pageLineIndex++;
                this.dataList[i].pageLineIndex = pageLineIndex;
              } else {
                if (this.dataList[i].type !== this.QuestionType.TITLE) {
                  questionIndex++;
                  this.dataList[i].questionIndex = questionIndex;
                }
              }
            }
          }
        })
        .catch((err) => {
          this.loading.close();
          console.log("err", err);
        });
    },
    endMethod() {
      closeQuestionnaire({
        uuid: this.surveyid,
      })
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "成功",
              type: "success",
            });
            this.$emit("close-dialog");
            this.$emit("update");
          } else {
            this.$message({
              message: res.msg,
              type: "failed",
            });
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
    editClick() {
      if (this.questionnaireType === "1") {
        this.$router.push({
          path: "/create",
          query: {
            id: this.surveyid,
          },
        });
      } else if (this.questionnaireType === "2") {
        this.$router.push({
          path: "/examCreate",
          query: {
            id: this.surveyid,
          },
        });
      } else {
        this.$router.push({
          path: "/evaluationCreate",
          query: {
            id: this.surveyid,
          },
        });
      }
    },
    downloadClick() {
      if (!this.checked) {
        this.$message({
          message: "请确认中心logo为我自行修改",
          type: "warning",
        });
        return;
      }
      console.log(this.surveyType === 1, this.dataObj);
      var name =
        this.surveyType === 1
          ? this.dataObj.templateQuestionnaireName
          : this.dataObj.questionnaireName;
      const x = new XMLHttpRequest();
      x.open("GET", this.qrcodeUrl, true);
      x.responseType = "blob";
      x.onload = function () {
        const url = window.URL.createObjectURL(x.response);
        const a = document.createElement("a");
        a.href = url;
        a.download = name + ".png";
        a.click();
      };
      x.send();
    },
    handleCopyClick(text) {
      const input = document.createElement("input");
      input.value = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
      this.$message({
        message: "复制成功",
        type: "success",
      });
    },
    // 获取问卷链接
    async getUrlLinkData(path, query) {
      await getUrlLink({
        path: path,
        query: query,
      }).then((res) => {
        if (res.code === 200) {
          this.questionLink = res.msg;
        }
      });
    },
    // 问卷问卷二维码
    async getQenerateQRCode() {
      await generateQRCode({
        uuid: this.surveyid,
        type: this.surveyType === 1 ? "2" : "1",
      }).then((res) => {
        console.log("res12321312312312312", res);
        if (res.code === 200) {
          this.qrcodeUrl = res.msg;
        }
      });
    },
    handleBlur(e) {
      // this.$refs.input.value = this.$refs.input.value.slice(0, 4);
      this.logoText = e.target.value;
      this.getLogoUrl();
    },
    handleIconClick(type) {
      this.logoText = type;
      this.getLogoUrl();
    },
    handleSelectColor(index) {
      this.selectColorIndex = index;
      this.logoColor = this.colors[this.selectColorIndex].color;
      this.getLogoUrl();
    },
    async getLogoUrl() {
      await generateQRCodeWithLogo({
        type: 1,
        uuid: this.surveyid,
        logoText: this.logoText, //字
        logoColor: this.logoColor,
      }).then((res) => {
        console.log("res12321312312312312", res);
        if (res.code === 200) {
          this.qrcodeUrl = res.msg;
        }
      });
    },
  },
  watch: {
    showDialog(newVal) {
      this.viseable = newVal;
      if (newVal) {
        this.selectColorIndex = null;
        this.logoText = "";
        this.logoColor = "#2578E3";
        // 组件显示时，强制滚动到顶部
        this.$nextTick(() => {
          const container = this.$refs.scrollContainer;
          if (container) {
            container.scrollTop = 0;
          }
        });
      }
    },
    params(newVal, oldVal) {
      if (!this.viseable || !newVal) return;
      if (oldVal && newVal.id === oldVal.id && newVal.type === oldVal.type) {
        return;
      }
      this.surveyid = newVal.id;
      this.surveyType = newVal.type;
      console.log("fwefwehfgwegfwe9031029y209ry2091yr9021ry01", newVal);

      if (this.questionnaireType === "1") {
        this.pagePath = `pages-other/QuestionDetails/QuestionDetails?operate=3&uuid=${newVal.id}`;
      } else if (this.questionnaireType === "2") {
        this.pagePath = `pages-other/ExamDetails/ExamDetails?operate=3&uuid=${newVal.id}`;
      } else {
        this.pagePath = `pages-evaluation/EvaluationDetails/EvaluationDetails?operate=3&uuid=${newVal.id}`;
      }

      this.getQenerateQRCode();
      if (newVal.type === 1) {
        this.fetchSurveyData(newVal.id);
        if (this.questionnaireType === "1") {
          this.getUrlLinkData(
            "pages-other/QuestionDetails/QuestionDetails",
            `operate=2&uuid=${this.surveyid}`,
          );
        } else if (this.questionnaireType === "2") {
          this.getUrlLinkData(
            "pages-other/ExamDetails/ExamDetails",
            `operate=2&uuid=${this.surveyid}`,
          );
        } else {
          this.getUrlLinkData(
            "pages-evaluation/EvaluationDetails/EvaluationDetails",
            `operate=2&uuid=${this.surveyid}`,
          );
        }
      } else {
        this.queryDetail();
        if (this.questionnaireType === "1") {
          this.getUrlLinkData(
            "pages-other/QuestionDetails/QuestionDetails",
            `operate=3&uuid=${this.surveyid}`,
          );
        } else if (this.questionnaireType === "2") {
          this.getUrlLinkData(
            "pages-other/ExamDetails/ExamDetails",
            `operate=3&uuid=${this.surveyid}`,
          );
        } else {
          this.getUrlLinkData(
            "pages-evaluation/EvaluationDetails/EvaluationDetails",
            `operate=3&uuid=${this.surveyid}`,
          );
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.flexs {
  display: flex;
}

.paddings {
  padding: 0;
}

.coverShow {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.container-gj {
  padding: 15px;
  position: fixed;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.65);
  /* border-radius: 8px; */
  z-index: 100;
  transform: translate(-50%, -50%);
  /* padding: 20px; */
  /* border: 2px dashed #6998ff; */
}

.container-gd {
  /* padding: 17px 28px; */
  position: fixed;
  top: 50%;
  left: 50%;
  /* width: 960px; */
  height: 780px;
  background: #f8f8f8;
  /* border-radius: 8px; */
  z-index: 100;
  transform: translate(-50%, -50%);
  overflow: hidden;
  display: flex;
  border-radius: 8px;
}

.container-gd::-webkit-scrollbar {
  display: none;
}

.close-div {
  position: fixed;
  /* top: 50%; */
  left: 50%;
  /* transform: translate(-50%, -50%); */
  z-index: 100;
  cursor: pointer;
  margin-left: 350px;
  /* margin-top: -300px; */
  top: 10vh;
}

.survey-container {
  /* max-width: 600px; */
  margin: 0 auto;
  background-color: #ffffff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
}

.header-banner {
  position: relative;
  overflow: hidden;
  gap: 34px;
}

.banner-image {
  width: 100%;
  max-width: 330px;
  height: auto;
  max-height: 220px;
  object-fit: cover;
  border-radius: 8px;
}

.banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(200, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.banner-content {
  text-align: center;
  color: #fff;
}

.banner-title {
  font-size: 24px;
  font-weight: bold;
  margin: 0;
}

.banner-subtitle {
  font-size: 14px;
  margin: 5px 0 0;
}

.survey-info {
  /* flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  background-color: #fff; */
  width: 480px;
  padding: 10px;
  box-sizing: border-box;
  background: #ffffff;

  h1 {
    width: 100%;
    font-size: 18px;
    font-family: PingFang SC, PingFang SC-Medium;
    font-weight: Medium;
    text-align: left;
    color: #323b5a;
    text-align: center;
  }

  h4 {
    font-size: 13px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: Regular;
    text-align: left;
    color: #7e7e81;
    line-height: 18px;
  }
}

.survey-title {
  flex-direction: column;
  gap: 5px;
}

.survey-title h1 {
  font-size: 16px;
  font-family: auto;
  font-weight: bold;
  color: #333;
  margin: 0;
  margin-bottom: 10px;
}

.survey-title div {
  font-size: 14px;
  color: #666;
}

.survey-stats {
  margin-top: 40px;
}

.free-use-btn {
  background-color: #1877ff;
  color: white;
  border: none;
  border-radius: 26px;
  /* padding: 10px 60px; */
  cursor: pointer;
  color: #fff;
  font-size: 14px;
  height: 44px;
  width: calc(100% - 30px);
  position: absolute;
  bottom: 10px;
  margin-left: 15px;
}

.survey-description {
  margin-top: 18px;
  margin-bottom: 22px;
  flex-direction: column;
  gap: 5px;
}

.survey-description h1 {
  color: #333;
  font-size: 16px;
  font-family: auto;
  font-weight: bold;
  margin: 0;
}

.survey-description p {
  font-size: 12px;
  color: #666;
}

.questions-list {
  /* padding: 0 15px; */
  width: 100%;
  width: 480px;
  padding: 0 15px;
  box-sizing: border-box;
  background: #ffffff;
}

.question-item {
  /* padding: 15px 0; */
  margin-top: 10px;
}

.question-title {
  font-size: 14px;
  font-weight: bold;
  font-family: auto;
  margin-bottom: 10px;
  color: #333;
}

.options-list {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.option-item {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.radio-option input,
.checkbox-option input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.radio-button {
  position: relative;
  display: inline-block;
  width: 11px;
  height: 11px;
  border: 2px solid #ddd;
  border-radius: 50%;
  margin-right: 10px;
}

.radio-option input:checked ~ .radio-button {
  background: #1877ff;
  border-color: #1877ff;
}

.radio-option input:checked ~ .radio-button:after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(45deg);
  width: 3px;
  height: 6px;
  margin-top: -1px;
  border-right: 2px solid #fff;
  border-bottom: 2px solid #fff;
  border-radius: 1px;
}

.checkbox-button {
  position: relative;
  display: inline-block;
  width: 10px;
  height: 10px;
  border: 2px solid #ddd;
  border-radius: 3px;
  margin-right: 10px;
}

.checkbox-option input:checked ~ .checkbox-button {
  background-color: #1877ff;
  border-color: #1877ff;
}

.checkbox-option input:checked ~ .checkbox-button:after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(45deg);
  width: 3px;
  height: 6px;
  margin-top: -1px;
  border-right: 2px solid #fff;
  border-bottom: 2px solid #fff;
  border-radius: 1px;
}

.option-text {
  font-size: 12px;
  color: #666;
}

.fill-blank textarea {
  width: 100%;
  min-height: 30px;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  resize: vertical;
  resize: none;
}

.fill-blank textarea::-webkit-scrollbar {
  display: none;
}

.fill-blank .title {
  font-size: 12px;
  color: #333;
  margin-bottom: 5px;
}

.rating-subtitle {
  font-size: 14px;
  color: #666;
  margin-bottom: 10px;
}

.star-rating {
  display: flex;
  gap: 5px;
}

.star {
  font-size: 24px;
  color: #ddd;
  cursor: pointer;
  font-family: auto;
}

.star.active {
  color: #ffa500;
}

.dropdown-select {
  position: relative;
}

.dropdown-select select {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  appearance: none;
  background-color: #fff;
  font-size: 14px;
}

.dropdown-arrow {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%) rotate(45deg);
  width: 8px;
  height: 8px;
  margin-top: -2px;
  border-right: 2px solid #9b9fac;
  border-bottom: 2px solid #9b9fac;
  /* pointer-events: none; */
  /* color: #666; */
}

.text-display {
  background-color: #f7f7f7;
  padding: 10px 15px;
  border-radius: 4px;
  border: 1px solid #ededed;
}

.text-display p {
  margin: 0;
  font-size: 14px;
  line-height: 1.6;
  color: #666;
}

.number-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.number-btn {
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ededed;
  background-color: #f9f9f9;
  font-size: 13px;
  cursor: pointer;
  color: #2b2f36;
  font-weight: bold;
  font-family: auto;
}

.number-btn.active {
  background-color: #4a73f8;
  color: #fff;
  border-color: #4a73f8;
}

.score-info {
  font-size: 14px;
  margin-top: 20px;
  margin-bottom: 15px;
  color: #2b2f36;
}

.score-info span {
  color: #1890ff;
}

.score-buttons {
  display: flex;
  gap: 34px;
}

.score-btn {
  width: 27px;
  height: 27px;
  border-radius: 50%;
  border: 1px solid #ededed;
  background-color: #fff;
  font-size: 13px;
  cursor: pointer;
  font-weight: bold;
}

.score-btn.active {
  background-color: #3a60ff;
  color: #fff;
  border-color: #3a60ff;
}

.slider-container {
  margin: 20px 0;
}

.slider {
  width: 100%;
  height: 5px;
  -webkit-appearance: none;
  appearance: none;
  background: #ddd;
  outline: none;
  border-radius: 5px;
}

.slider::-webkit-slider-thumb {
  appearance: none;
  width: 15px;
  height: 15px;
  background: #fff;
  border: 2px solid #3a60ff;
  border-radius: 50%;
}

.slider::-moz-range-thumb {
  width: 16px;
  height: 16px;
  background: #3a60ff;
  border-radius: 50%;
  border: none;
}

.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #fff;
  cursor: pointer;
}

.slider-labels {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 5px;
  font-size: 12px;
  color: #2b2f36;
  gap: 6px;
}

.matrix-questions {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 18px;
}

.matrix-row {
  display: flex;
  flex-direction: column;
}

.matrix-label {
  font-size: 13px;
  color: #2b2f36;
  margin-bottom: 6px;
}

.matrix-input {
  flex: 1;
  padding: 10px 15px;
  border: 1px solid #ededed;
  border-radius: 4px;
  font-size: 14px;
}

.submit-container {
  padding: 20px 15px;
  text-align: center;
}

.submit-button {
  background-color: #1890ff;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 12px 30px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.submit-button:hover {
  background-color: #40a9ff;
}

.right-container {
  width: 357px;
  background: #f8f8f8;
  /* margin-left: 10px; */
  display: flex;
  flex-direction: column;
  align-items: center;
}

.tab-container {
  display: flex;
  margin-top: 15px;
}

.tab-left {
  width: 131px;
  height: 39px;
  /* background: #3b63ff; */
  border: 0.74px solid #4a73f8;
  border-radius: 74px 0px 0px 74px;
  text-align: center;
  line-height: 39px;
  font-size: 13px;
  font-family: Microsoft YaHei, Microsoft YaHei-Bold;
  font-weight: Bold;
  cursor: pointer;
}

.tab-right {
  width: 131px;
  height: 39px;
  /* background: #ffffff; */
  border: 0.74px solid #3b63ff;
  border-radius: 0px 74px 74px 0px;
  text-align: center;
  line-height: 39px;
  font-size: 13px;
  font-family: Microsoft YaHei, Microsoft YaHei-Bold;
  font-weight: Bold;
  cursor: pointer;
}

.tab-active {
  background: #3b63ff;
  color: #fff;
}

.tab-inactive {
  background: #fff;
  color: #3b63ff;
}

.download-btn {
  width: 128px;
  height: 31px;
  background: #3b63ff;
  border-radius: 4px;
  font-size: 13px;
  font-family: Microsoft YaHei, Microsoft YaHei-Bold;
  font-weight: Bold;
  color: #ffffff;
  margin-top: 20px;
}

.wj-text {
  width: 61px;
  height: 20px;
  font-size: 15px;
  font-family: Microsoft YaHei, Microsoft YaHei-Bold;
  font-weight: Bold;
  text-align: left;
  color: #191919;
  line-height: 20px;
  margin-top: 20px;
}

.link-bg {
  width: 301px;
  background: #f6f6f6;
  border: 1.09px solid #e8e8e8;
  border-radius: 4px;
  padding: 10px;
  box-sizing: border-box;
  margin-top: 10px;
}

.link-div {
  font-size: 15px;
  font-family: Microsoft YaHei, Microsoft YaHei-Regular;
  font-weight: Regular;
  text-align: left;
  color: #666666;
  line-height: 20px;
}

.copy-btn {
  width: 61px;
  height: 36px;
  background: #3b63ff;
  border-radius: 18px;
  font-size: 15px;
  font-family: Microsoft YaHei, Microsoft YaHei-Bold;
  font-weight: Bold;
  color: #ffffff;
}

.question-container {
  /* width: 330px; */
  padding: 10px;
  box-sizing: border-box;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
}

.choose-item {
  width: 100%;
  min-height: 41px;
  padding: 10px 14px;
  background: #f7f7f7;
  border: 0.89px solid #ededed;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.choose-item-text {
  font-size: 13px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: Regular;
  text-align: left;
  color: #2b2f36;
}

.choose-item-circle {
  width: 14px;
  height: 14px;
  background: #ffffff;
  border: 0.93px solid rgba(74, 115, 247, 0.5);
  border-radius: 50%;
}

.top-nav {
  width: 100%;
  height: 50px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-sizing: border-box;
  border-bottom: 1px solid #e7e7e7;
}

.id-container {
  width: 100%;
  padding: 15px;
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 9px;
  margin-top: 10px;

  p {
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: Regular;
    text-align: left;
    color: #474747;

    span {
      font-family: PingFang SC, PingFang SC-Semibold;
      font-weight: Semibold;
      color: #010100;
    }
  }

  .fuzhi-div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 15px;

    p {
      font-size: 12px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: Regular;
      text-align: left;
      color: #3a60ff;

      span {
        font-size: 12px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: Regular;
        text-align: left;
        color: #f73b42;
      }
    }

    .fuzhi {
      width: 62px;
      height: 30px;
      background: rgba(47, 145, 249, 0.1);
      border-radius: 20px;
      font-size: 13px;
      font-family: PingFang SC, PingFang SC-Semibold;
      font-weight: Semibold;
      color: #3192f8;
    }
  }
}

.center-line {
  width: 7px;
  height: 100%;
  background: #d8d8d8;
}

.bottom-btn {
  width: calc(100% - 30px);
  /* height: 44px; */
  background: #fff;
  display: flex;
  align-items: center;
  /* padding: 0 20px; */
  /* box-sizing: border-box; */
  border: 1px solid #e5e5e5;
  margin-left: 15px;
  border-radius: 7px;
}

.bottom-btn-line {
  width: 1px;
  height: 24px;
  background: #e5e5e5;
}

.bottom-btn-item {
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 44px;
  cursor: pointer;

  img {
    width: 18px;
    height: 18px;
  }

  p {
    font-size: 15px;
    font-weight: 600;
    color: #323b5a;
    margin-left: 4px;
  }
}

.download-container {
  margin-top: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 320px;
  /* padding: 20px 0; */
  background: #fff;
  height: calc(100% - 125px);
  overflow: hidden;
  overflow-y: auto;
  border-radius: 5px;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.embed-container {
  padding: 0 10px;
  box-sizing: border-box;
  height: calc(100% - 115px);
  overflow: hidden;
  overflow-y: auto;
}

.image-view {
  width: 77px;
  height: 77px;
  background: #f4f4f4;
  border-radius: 3px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 10px;
  /* position: relative; */

  .plus-icon {
    position: relative;
    width: 17px;
    height: 17px;
    margin-top: 15px;
    margin-bottom: 8px;
  }

  .plus-icon::before,
  .plus-icon::after {
    content: "";
    position: absolute;
    background-color: #b2b7bf;
  }

  .plus-icon::before {
    left: 50%;
    top: 0;
    width: 1px;
    height: 100%;
    transform: translateX(-50%);
  }

  .plus-icon::after {
    top: 50%;
    left: 0;
    width: 100%;
    height: 1px;
    transform: translateY(-50%);
  }

  p {
    font-size: 10px;
    font-weight: 400;
    color: #798497;
  }

  .delete {
    position: absolute;
    width: 13px;
    height: 13px;
    top: 3px;
    right: 3px;
  }
}

.item {
  margin-top: 10px;
}

.mask-div {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  z-index: 100;
}

.text-icon {
  width: 30px;
  height: 30px;
  display: inline-block;
  background-color: #2577e4;
  font-size: 11px;
  border-radius: 50%;
  color: #fff;
  text-align: center;
  line-height: 30px;
  margin-left: 5px;
  cursor: pointer;
}

.select-image {
  width: 28px;
  height: 20px;
  transform: scale(0.8);
}
</style>



// WEBPACK FOOTER //
// src/components/QuestionTemplate/index.vue